import Skeleton from 'react-loading-skeleton';
import React from 'react';

const Page = React.lazy(()=>import('./Video'))

export default function LazyVideoLoader({source, poster, autoplay, controls}){
    return <React.Suspense fallback={<Skeleton height={240} />}>
        <Page source={source} poster={poster} autoplay={autoplay} controls={controls} />
    </React.Suspense>
}

LazyVideoLoader.propTypes = {}
